/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TaskBoardCardEnum {
    ONLINE_SUBMISSION = 1,
    NEW_BUSINESS = 2,
    RENEWAL = 3,
    IN_PROGRESS_NEW_BUSINESS = 4,
    WAITING_INFO = 5,
    QUOTED = 6,
    INDICATION = 7,
    READY_TO_BIND = 8,
    RENEWAL_READY_TO_BIND = 9,
    NEW_BUSINESS_BOUND = 10,
    RENEWAL_BOUND = 11,
    LOST = 12,
    DECLINED = 13,
    CANCELLED = 14,
    OTHER = 15,
    RECENTS = 16,
    RECENT_AND_PINNED = 17,
    TASKS = 18,
    DUE_SELECTED_DATE = 19,
    ASSIGNED_FILES = 20,
    NOTES_IN_PAST_7_DAYS = 21,
    CREATED = 22,
    ORDERED = 23,
    RE_ORDERED = 24,
    LATE = 25,
    RECEIVED = 26,
    WAITING_FOR_INFO = 27,
    REFUNDS = 28,
    INVOICED = 29,
    DISPUTED = 30,
    ESTIMATED = 31,
    CLOSED_FLAT = 32,
    COLLECTIONS = 33,
    IN_PROGRESS_RENEWAL = 34,
}
